/**
 * Shared identifiers for the Brand Refresh navigation Spotlight tour.
 *
 * The tour has one entry point (the "New Calendly tour card" pinned to the top of the nav footer)
 * and four steps that highlight elements inside the new vertical nav. Dismissal is persisted to the
 * backend via {@link useBrandRefreshNavTourState}, mirroring the other product tours in the app.
 */

/** `?show_brand_refresh_tour=1` forces the card/tour to appear even after dismissal, for QA. */
export const BRAND_REFRESH_NAV_TOUR_FORCE_SHOW_PARAM = 'show_brand_refresh_tour'

/**
 * Stable `itemId` / `data-item-id` for the footer Settings row in `AppShellVerticalNavView`. Defined
 * here so the nav (which renders it) and the tour (which targets its final step) share one value.
 */
export const SHELL_NAV_SETTINGS_ITEM_ID = 'shell-nav-settings'
